import { Box } from '@mui/material';
import KPICard from './KPICard';
import KPIPieChart from '../Helpers/KPi.Pie';
import {
  type KPIHeaderValuePair,
  type MaintenanceDataInterface,
} from '../Interfaces/KPI.interface';
import useAppTheme from 'hooks/useAppTheme';
import { ThemePalette } from 'views/SurvivalAnalysis/Helper/Icons/theme.squares';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  totalTonnageOfAllAssets: KPIHeaderValuePair[];
  totalCosts: {
    total_cost: number;
    total_labour_cost: number;
    total_part_cost: number;
  };
  maintenanceData: MaintenanceDataInterface;
  totalCurrentPmVsCmHrs: {
    pm: number;
    cm: number;
  };
}

const GraphsTab = ({
  totalTonnageOfAllAssets,
  totalCosts,
  maintenanceData,
  totalCurrentPmVsCmHrs,
}: Props) => {
  const { t } = useTranslation();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return (
    <>
      <Box marginBottom={1}>
        <KPICard
          title={t('total_tonnage_2')}
          values={totalTonnageOfAllAssets}
          totalType=""
        />
        <KPIPieChart
          title={t('maintenance_costs_overview')}
          label1="Parts"
          label2="Labour"
          number1={Number(totalCosts.total_part_cost.toFixed(2))}
          number2={Number(totalCosts.total_labour_cost.toFixed(2))}
          totalType="USD"
          enableDarkTheme={enableDarkTheme}
          precision={2}
          color1={ThemePalette.pie.blue}
          color2={ThemePalette.pie.green}
        />
      </Box>
      <Box marginBottom={1}>
        <KPIPieChart
          title={t('maintenance_costs_pm_vs_cm')}
          label1="PM"
          label2="CM"
          number1={maintenanceData.pmTotalCost}
          number2={maintenanceData.cmTotalCost}
          totalType="USD"
          enableDarkTheme={enableDarkTheme}
          precision={2}
          color1={ThemePalette.pie.blue}
          color2={ThemePalette.pie.green}
        />
      </Box>{' '}
      <Box marginBottom={1}>
        <KPIPieChart
          title={t('work_order_count_pm_vs_cm')}
          label1="PM"
          label2="CM"
          number1={maintenanceData.pmTotalQuantity}
          number2={maintenanceData.cmTotalQuantity}
          totalType=""
          enableDarkTheme={enableDarkTheme}
          precision={0}
          color1={ThemePalette.pie.blue}
          color2={ThemePalette.pie.green}
        />
      </Box>{' '}
      <Box marginBottom={1}>
        <KPIPieChart
          title={t('maintenance_hours_pm_vs_cm')}
          label1="PM"
          label2="CM"
          number1={totalCurrentPmVsCmHrs?.pm}
          number2={totalCurrentPmVsCmHrs?.cm}
          totalType="hrs"
          enableDarkTheme={enableDarkTheme}
          precision={0}
          color1={ThemePalette.pie.blue}
          color2={ThemePalette.pie.green}
        />
      </Box>
    </>
  );
};

export default GraphsTab;
